<div class="main_section">
    <div class="plan_header_section">
        <div class="box_section">
            <div>
                <div class="content_section">
                    <h3 *ngIf="getTitleText()">{{ getTitleText() }}</h3>
                    <p>Thank you for using Supersee.</p>
                    <p *ngIf="isAdmin">
                        To continue seeing all reports & screenshots, please 
                        <a style="cursor: pointer;" (click)="sendPaymentRequest()" *ngIf="getActionText()">
                            {{ getActionText() }}
                        </a> your plan.
                    </p>
                    <p *ngIf="!isAdmin">Please reach out to your administrator for assistance.</p>
                </div>
            </div>
            <div class="btn_section" *ngIf="isAdmin && getButtonText()">
                <button class="buy_now" (click)="sendPaymentRequest()">{{ getButtonText() }}</button>
            </div>
        </div>
    </div>
</div>